import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'

import { CTAButtonWithWT } from '@f-fertighaus/applications/Next/components/common/CTAButton'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { useSimilarHousesData } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/SimilarHouses/hooks/useSimilarHousesData'
import { useSimilarHousesSearchParam } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/SimilarHouses/hooks/useSimilarHousesSearchParam'
import { SimilarHousesCarousel } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/SimilarHouses/SimilarHousesCarousel'
import { getUrl } from '@js/common/getUrlByDomain'

import ErrorBoundary from '../components/common/ErrorBoundary'

export const InactiveVendorHouses = () => {
  const { state: houseDetailData } = useHouseDetail()
  const { data: similarHouses, status } = useSimilarHousesData(
    houseDetailData.nid
  )
  const isActive = houseDetailData.active

  const similarHousesSearchParam = useSimilarHousesSearchParam(houseDetailData)

  if (!similarHouses) return null

  return (
    <>
      {!isActive && (
        <Container>
          <Typography variant='mediumTitle' component='h2' display='block'>
            {t('inactiveVendorHouses.header')}
          </Typography>
          <Typography
            variant='body1'
            component='h2'
            display='block'
            sx={{ marginBottom: '16px' }}>
            {t('inactiveVendorHouses.description')}
          </Typography>
          <ErrorBoundary>
            <SimilarHousesContainer>
              <SimilarHousesCarousel
                similarHouses={similarHouses}
                status={status}
              />
            </SimilarHousesContainer>
          </ErrorBoundary>
          <CTAContainer>
            <CTAButtonWithWT
              variant='contained'
              color='secondary'
              href={`${getUrl('houseList')()}?${similarHousesSearchParam}`}
              wtPayload={{
                category: 'CTA-link',
                action: 'click',
                label: 'view-other-houses',
                indicates: ['funnel-entry'],
                location: 'similar-houses-section',
                values: [{ value: '(ICON)', type: 'text' }]
              }}>
              {t('inactiveVendorHouses.cta')}
            </CTAButtonWithWT>
          </CTAContainer>
        </Container>
      )}
    </>
  )
}

const Container = styled(Box)`
  padding: ${({ theme }) => theme.spacing(3, 4)};
`

const SimilarHousesContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
  label: InactiveVendrHousesSimilarHousesContainer;
`

export const CTAContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  label: InactiveVendrHousesCTAContainer;
`
